export default __webpack_public_path__ + "static/media/location_preview_saucer_spin.4da9d65c.svg";